import iconImg from "@PUBLIC/M/images/btn/btn_spr.png";
import styled from "@yb/styled-px2rem";

const ResetButton = styled.button`
	position: absolute;
	top: 7px;
	left: 15px;
	display: block;
	z-index: 1;
	width: 34px;
	height: 34px;
	border-radius: 50%;
	background: #fff;
	&:before {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 1;
		display: block;
		width: 17px;
		height: 17px;
		background: url(${iconImg}) no-repeat 0 0;
		background-size: 100px auto;
		background-position: -14px -15px;
		transform: translate(-50%, -50%);
		content: "";
	}
`;

export default ResetButton;
